import { Alert, Anchor, List, Text, Title } from "@mantine/core";
import type { Meter } from "../../../../../../utils/backend-types";
import { getErrorText } from "../../../../../../utils/get-error-text";

interface SiteInfoProps {
  loading: boolean;
  sitePlausibilityError: Error | null;
  noMeters: boolean;
  unplausibleMeters: Array<Meter>;
  onClickMeter: (id: number) => void;
}

function SiteInfo({
  loading,
  sitePlausibilityError,
  noMeters,
  unplausibleMeters,
  onClickMeter
}: SiteInfoProps) {
  let alertColor = "success";
  let alertMessage: string | React.ReactNode = `
      Zum aktuellen Zeitpunkt haben wir keine Hinweise auf unplausible Werte in
      den hochgeladenen Zeitreihen gefunden. Zeiträume ohne Energiedaten werden
      nicht bewertet.`;

  if (loading) {
    alertColor = "info";
    alertMessage = "Die Energiedaten werden auf Plausibilität geprüft...";
  } else if (sitePlausibilityError) {
    alertColor = "error";
    alertMessage = getErrorText(sitePlausibilityError);
  } else if (unplausibleMeters.length > 0) {
    alertColor = "warning";
    alertMessage = (
      <>
        <Title fw={500} mb={5} order={5}>
          Hinweis auf unplausible Daten:
        </Title>
        <Text mb="sm">
          Bei der Überprüfung der Energiedaten haben wir Auffälligkeiten
          gefunden. Bitte prüfen Sie, ob es sich beispielsweise um fehlerhafte
          Daten handelt, welche durch Sie korrigiert werden können. Folgende
          Zähler sind betroffen:
        </Text>
        <List size="sm" withPadding>
          {unplausibleMeters.map((meter) => (
            <List.Item key={meter.id}>
              <Anchor component="span" onClick={() => onClickMeter(meter.id)}>
                {meter.name}
              </Anchor>
            </List.Item>
          ))}
        </List>
      </>
    );
  } else if (noMeters) {
    alertColor = "info";
    alertMessage = "Keine Zähler vorhanden.";
  }

  return (
    <Alert className="SiteInfo" color={alertColor} maw={700} mb="lg">
      {alertMessage}
    </Alert>
  );
}

export { SiteInfo, SiteInfoProps };
